module.exports = __webpack_public_path__ + "img/pdf.9ffb8846.svg";